import { RequestorMapping, RequestTypeMapping } from '../../../common/commons';

// Display order is alphabetical; array indices follow the reports API contract.
export const REPORT_RIGHTS = [
    { key: 'awl', abbr: 'AWL', ticketType: 'Add-Whitelist', columnMappingIndex: 0 },
    { key: 'da', abbr: 'DA', ticketType: 'Deactivate-Account', columnMappingIndex: 1 },
    { key: 'isr', abbr: 'ISR', ticketType: 'ISR', columnMappingIndex: 2 },
    { key: 'rwl', abbr: 'RWL', ticketType: 'Remove-Whitelist', columnMappingIndex: 3 },
    { key: 'rtc', abbr: 'RTC', ticketType: 'Right-to-Correct', columnMappingIndex: 4 },
    { key: 'rtd', abbr: 'RTD', ticketType: 'Right-to-Delete', columnMappingIndex: 6 },
    { key: 'rtk', abbr: 'RTK', ticketType: 'Right-to-Know-Detailed', columnMappingIndex: 7 },
    { key: 'rtoo', abbr: 'RTO', ticketType: 'Right-to-OptOut', columnMappingIndex: 8 },
    { key: 'rtt', abbr: 'RTT', ticketType: 'Right-to-Terminate', columnMappingIndex: 9 },
    { key: 'tvla', abbr: 'TVLA', ticketType: 'Terminate-Vehicle-Location-Access', columnMappingIndex: 5 },
    { key: 'ufv', abbr: 'UFV', ticketType: 'Unflag-VIN', columnMappingIndex: 10 },
].map(right => ({ ...right, label: RequestTypeMapping[right.ticketType] }));

export const DEACTIVATE_ACCOUNT_COLOR = '#f28c28';

export const getReportResponseKey = (key) => key === 'da' ? 'deactivate_account' : key;

const survivorRights = ['awl', 'da', 'isr', 'rwl', 'rtt', 'ufv'];
const standardRights = ['rtc', 'rtd', 'rtk', 'rtoo'];

export const isReportRightApplicable = (key, requestor = 'All') => {
    const normalizedKey = key.toLowerCase() === 'rto' ? 'rtoo' : key.toLowerCase();
    if (normalizedKey === 'total' || normalizedKey === 'totals') return true;
    const requestors = Array.isArray(requestor) ? requestor : [requestor];
    return requestors.some(value => {
        if (value === 'All') return true;
        if (value === RequestorMapping.SURVIVOR) return survivorRights.includes(normalizedKey);
        if (value === RequestorMapping.DRIVER) return normalizedKey === 'tvla';
        return standardRights.includes(normalizedKey);
    });
};

export const mapReportValues = (values) => Object.fromEntries(
    REPORT_RIGHTS.map(right => [right.key, values[right.columnMappingIndex]])
);
